export const IS_HIDDEN_FROM_PORTAL = 'is_hidden_from_portal';
export const AUTO_ADVANCE_ON_COMPLETION = 'auto_advance_on_completion';
export const SHOULD_AUTO_ADVANCE_WHEN_LABELS_COMPLETE =
  'should_auto_advance_when_labels_complete';
export const SHOW_ONE_QUESTION_AT_A_TIME = 'show_one_question_at_a_time';
